var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2802 18.2197C19.4208 18.3603 19.4999 18.5511 19.4999 18.75C19.4999 18.9489 19.4208 19.1397 19.2802 19.2804C19.1395 19.421 18.9488 19.5 18.7498 19.5C18.5509 19.5 18.3601 19.421 18.2195 19.2804L11.9998 13.0606L5.78018 19.2804C5.63952 19.421 5.44875 19.5 5.24984 19.5C5.05092 19.5 4.86015 19.421 4.71949 19.2804C4.57884 19.1397 4.49982 18.9489 4.49982 18.75C4.49982 18.5511 4.57884 18.3603 4.71949 18.2197L10.9392 12L4.71949 5.78036C4.57884 5.63971 4.49982 5.44894 4.49982 5.25002C4.49982 5.0511 4.57884 4.86033 4.71949 4.71968C4.86015 4.57902 5.05092 4.5 5.24984 4.5C5.44875 4.5 5.63952 4.57902 5.78018 4.71968L11.9998 10.9394L18.2195 4.71968C18.3601 4.57902 18.5509 4.5 18.7498 4.5C18.9488 4.5 19.1395 4.57902 19.2802 4.71968C19.4208 4.86033 19.4999 5.0511 19.4999 5.25002C19.4999 5.44894 19.4208 5.63971 19.2802 5.78036L13.0604 12L19.2802 18.2197Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDecline);
export default __webpack_public_path__ + "static/media/action-decline.6219e51b00875ee2f2c0116491c4058a.svg";
export { ForwardRef as ReactComponent };